export const RESET = 'EXCMAGREEMENTSLA_LIST_RESET'
export const SET_ITEMS = 'EXCMAGREEMENTSLA_LIST_SET_ITEMS'
export const SET_ERROR = 'EXCMAGREEMENTSLA_LIST_SET_ERROR'
export const SET_VIEW = 'EXCMAGREEMENTSLA_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXCMAGREEMENTSLA_LIST_TOGGLE_LOADING'
